import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { Spinner } from '../components/ui/Spinner'

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, loading, checkAuth } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (requireAuth) {
      checkAuth()
    }
  }, [])

  useEffect(() => {
    if (!loading && requireAuth && !isAuthenticated) {
      navigate('/admin/login')
    }
  }, [loading, requireAuth, isAuthenticated, navigate])

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-app dark:bg-app-dark">
        <Spinner size="lg" />
        <p className="text-sm text-text-muted dark:text-text-muted-dark">Loading…</p>
      </div>
    )
  }

  if (requireAuth && !isAuthenticated) {
    return null
  }

  return children
}

export default ProtectedRoute
